<template>
  <div class="home">
    <img class="yui_bg-main" src="../assets/bg-1.jpg" alt="">

    <div class="y-main">
      <van-notice-bar class="yui-notice-bar"
                      scrollable
                      :text="noticeBarText"/>
      <div class="yui_card-1">


        <div class="yui_card-1_item">
          <h5>成功邀请</h5>
          <p>
            <span>{{ inviteNum }}</span> 人
          </p>
        </div>
        <div class="yui_card-1_item">
          <h5>累计获得</h5>
          <p>
            <span>{{ totalCoinNum }}</span> 个能量
          </p>
        </div>
      </div>


      <div class="y_task">


        <div class="task-item"
             v-for="(item,index) in taskList"
             :key="'ta_'+index">


          <div v-show="item.type==='1'" class="yui_cell-bd">
            钱包用户每日首次乘车 <span class="s1">+1能量 </span> （{{ item.curNum }}/{{ item.maxNum }}）
          </div>
          <div v-show="item.type==='2'"
               class="yui_cell-bd  yui_cell-bd-after-label">
            被邀用户每日首次乘车 <span class="s1">+2能量 </span> （{{ item.curNum }}/{{ item.maxNum }}）
          </div>
          <div v-show="item.type==='3'" class="yui_cell-bd">
            建设银行数字人民币子钱包每日首次乘车 <span class="s1">+1能量 </span> （{{ item.curNum }}/{{ item.maxNum }}）
          </div>

          <div class="yui_cell-ft">
            <van-button class="yBtn-m"
                        v-show="item.status==='2'"
                        size="mini"
                        color="#ff9418">本月已完成
            </van-button>
            <van-button class="yBtn-m"
                        v-show="item.status==='1'"
                        size="mini"
                        color="#ff9418">今日已完成
            </van-button>
            <van-button class="yBtn-m"
                        v-show="item.status==='0'"
                        disabled
                        size="mini"
                        color="#ff9418">今日未完成
            </van-button>
            <van-button class="yBtn-m"
                        v-show="item.status==='3'"
                        disabled
                        size="mini"
                        color="#ff9418">已过期
            </van-button>

          </div>


        </div>
        <!--    <div class="task-item">

              <div class="yui_cell-ft">
                <van-button class="yBtn-m" disabled  size="mini" color="#ff9418">今日未完成</van-button>
              </div>

            </div>-->
      </div>


      <img class="btn-toDetail"
           src="../assets/btn-toDetail.png"
           @click="toUserWallet"
           alt="点击查看详情">


    </div>

    <img class="btn-toExchangePrize"
         src="../assets/btn-toExchangePrize.png"
         @click="toExChange"
         alt="点击兑换奖品">
    <p class="toExChange-text">奖品在10月1日17:00活动开始后起兑</p>

    <img class="link-1"
         src="../assets/other-link.png"
         @click="toLink1"
         alt="">


    <div class="yui-fix-footer">
      <img class="btn-invite"
           v-show="(activityStatus==='1'&&walletStatus)||(invitePhone===''&&activityStatus!=='3'&&activityStatus!=='2'&&activityStatus!=='0')"
           src="../assets/btn-invite.png"
           @click="toShare"
           alt="立即邀请">
      <img class="btn-invite"
           v-show="activityStatus==='1'&&(!walletStatus)&&invitePhone!==''"
           src="../assets/btn-wallet-no-open.png"
           @click="towallet"
           alt="开通钱包立即参与">
      <img class="btn-invite"
           v-show="activityStatus==='0'"
           @click="toYalert('活动尚未开始')"
           src="../assets/btn-activity-no-open.png"
           alt="活动尚未开始">
      <img class="btn-invite"
           v-show="activityStatus==='2'"
           @click="toYalert('活动已结束')"
           src="../assets/btn-activity-over.png"
           alt="活动已结束"> <img class="btn-invite"
                             v-show="activityStatus==='3'"
                             @click="toYalert('活动已结束')"
                             src="../assets/btn-activity-over.png"
                             alt="活动已结束">
      <!--            <img class="btn-invite"
                       src="../assets/btn-open-wallet.png"
                       alt="开通钱包立即参与活动">-->
    </div>

  </div>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import {
  isVaildActivity
} from "@/services/api";
import noticeText from "@/views/noticeText";
import {
  ActivityStartTime
} from "@/config";

export default {
  name: 'HomePage',
  data() {
    return {
      pageStatus: '',
      activityStatus: '',
      activityNo: 'COINCOIN10',
      coinNum: 0,
      inviteNum: 0,
      totalCoinNum: 0,
      userPhone: '',
      taskList: []
    }
  },
  components: {
    // HelloWorld
  },
  computed: {
    invitePhone() {
      return this.$store.state.user.phone
    },
    walletStatus() {
      return this.$store.state.user.walletStatus
    },
    noticeBarText() {
      return noticeText.join(' ')
    }

  },
  mounted() {
    window['iosGetInfo'] = (result) => {
      this.iosGetInfo(result)
    }
    this.toGetUser()
    let that = this
    document.addEventListener('visibilitychange', function () {
      // 页面变为不可见时触发

      // 页面变为可见时触发
      if (document.visibilityState === 'visible') {
        if (that.$store.state.user.token === '' && that.$store.state.user.deviceCoding !== '') {
          that.toGetUser()
        }

      }
    });
        // this.$store.dispatch('handLocalSaveLoginInfo', {
        //   token: '55B36D4F0BAD0DFE8CA7E3F18F0F8055',
        //   deviceCoding: 'qeb',
        //   phone: '13070773538'
        // }).then(res => {
        //   console.log(res)
        //   that.getPageInfo(this.$store.state.user.token, this.$store.state.user.deviceCoding)
        //
        // }).catch(err => {
        //   console.error('login', err)
        // })

  },
  methods: {
    toYalert(msg) {
      this.$toast(msg)
    },
    getWalletStatus(token, deviceCoding) {
      // let that=this
      this.$store.dispatch('handGetWalletStatus', {
        token: token,
        deviceCoding: deviceCoding
      }).then(res => {
        console.log(res)
      }).catch(err => {
        console.error(err)
      })
    },
    toGetUser() {
      // if (this.$store.state.app.shell === 'bestugo') {
      let that = this
      this.$store.dispatch('getSystemInfo').then(res => {
        that.systemInfo = res
        if (res.system === 'ios') {

          window.webkit.messageHandlers.QDMETRO_H5_MESSAGE.postMessage("iosGetInfo")
        } else if (res.system === 'android') {
          let token = window.AndroidWebView.getTokenForH5();
          let deviceCoding = window.AndroidWebView.getDeviceCoding()
          let phone = window.AndroidWebView.getPhoneForH5()
          // resolve(systemInfo)
          if (token) {
            that.token = token;
            that.deviceCoding = deviceCoding
            that.userPhone = phone
            this.$store.dispatch('handLocalSaveLoginInfo', {
              token,
              deviceCoding,
              phone
            }).then(res => {
              console.log(res)
              that.getPageInfo(token, deviceCoding)
            })


          } else {
            if (deviceCoding) {
              this.$store.dispatch('handLocalSaveLoginInfo', {
                token: '',
                deviceCoding,
                phone: ''
              }).then(res => {
                console.log(res)
                // that.getPageInfo(token, deviceCoding)
              })
            }

          }
        }
      }).catch(err => {
        console.error(err)
      })

      // }
    },
    toGetUser2() {
      // if (this.$store.state.app.shell === 'bestugo') {
      let that = this
      this.$store.dispatch('getSystemInfo').then(res => {
        that.systemInfo = res
        if (res.system === 'ios') {

          window.webkit.messageHandlers.QDMETRO_H5_LOGIN_CALLBACK.postMessage("iosGetInfo")
        } else if (res.system === 'android') {
          let token = window.AndroidWebView.getTokenForH5();
          let deviceCoding = window.AndroidWebView.getDeviceCoding()
          let phone = window.AndroidWebView.getPhoneForH5()
          // resolve(systemInfo)
          if (token) {
            that.token = token;
            that.deviceCoding = deviceCoding
            that.userPhone = phone
            this.$store.dispatch('handLocalSaveLoginInfo', {
              token,
              deviceCoding,
              phone
            }).then(res => {
              console.log(res)
              that.getPageInfo(token, deviceCoding)
            })


          } else {
            window.AndroidWebView.loginForH5();
          }
        }
      }).catch(err => {
        console.error(err)
      })

      // }
    },
    iosGetInfo(obj) {

      let that = this
      if (obj.user_is_login === "1") {
        this.token = obj.user_token;
        this.deviceCoding = obj.phone_device_coding;
        this.userPhone = obj.user_phone;
        this.$store.dispatch('handLocalSaveLoginInfo', {
          token: obj.user_token,
          deviceCoding: obj.phone_device_coding,
          phone: obj.user_phone
        }).then(res => {
          console.log(res)
          that.getPageInfo(obj.user_token, obj.phone_device_coding)
        })

      } else {
        this.token = '';
        this.deviceCoding = obj.phone_device_coding;
        this.userPhone = '';
        this.$store.dispatch('handLocalSaveLoginInfo', {
          token: '',
          deviceCoding: obj.phone_device_coding,
          phone: ''
        }).then(res => {
          console.log(res)
          // that.getPageInfo(obj.user_token, obj.phone_device_coding)
        })
      }


    },
    getPageInfo(token, deviceCoding) {
      let that = this
      this.$store.dispatch('handGetUserCoinInfo', {
        token,
        deviceCoding
      }).then(res => {
        console.log(res)
        that.coinNum = res.coinNum
        that.inviteNum = res.inviteNum
        that.totalCoinNum = res.totalCoinNum
        that.taskList = res.taskList
      }).catch(err => {
        this.$toast(err)
        console.error(err)
      })
      this.getWalletStatus(token, deviceCoding)
      this.getActivityStatus(token, deviceCoding)
    },

    getActivityStatus(token, deviceCoding) {
      let robj = new FormData();
      let that = this
      robj.append('token', token)
      robj.append('deviceCoding', deviceCoding)
      robj.append('activityNo', this.$store.state.activityNo)
      isVaildActivity(robj).then(res => {
        console.log(res)
        if (res.respcod === '01') {
          /*
          0-未开始，
          1-进行中，
          2-已结束，
          3-不存在
          */
          that.activityStatus = res.data.status
          // that.logList = res.data


        } else {
          this.$toast(res.respmsg)
        }


      }).catch(onerror => {
        console.error(onerror)
        this.$toast('网络错误')
      })
    },

    toUserWallet() {
      if (this.$store.state.app.shell === 'wechat') {
        window.location.href = "http://www.bestugo.com/metro/download.html"
        return false

      } else if (this.$store.state.app.shell !== 'bestugo' && this.$store.state.user.deviceCoding === '') {
        window.location.href = "http://www.bestugo.com/metro/download.html"
        return false
      }
      if (this.$store.state.user.token === '') {
        this.toGetUser2()
        return false
      }

      let that = this
      if (!this.walletStatus) {
        this.$dialog.confirm({
          title: '请先开通钱包',
          message: '当前活动需开通钱包方可参与',
          confirmButtonText: '去开通',
          cancelButtonText: '我已开通',
          closeOnPopstate: false,
          beforeClose: ((action, done) => {
            if (action === 'confirm') {

              // setTimeout(done, 1000);

              done(false)
              // that.toGetUser2()
              window.location.href = "com.qdmetro://wallet/index";
            } else {
              that.toGetUser()
              done();
            }
          })
        });
        return false
      }


      if (this.activityStatus === '0') {
        this.$toast('活动未开始')
        return false
      }
      /*  if(this.activityStatus==='3'){
          this.$toast('活动不存在')
          return false
        }*/
      /*   if(this.activityStatus==='2'){
           this.$toast('活动已结束')
           return false
         }*/
      if (this.activityStatus === '') {

        return false
      }

      this.$router.push({
        name: 'userFortuneCoin'
      })


    },
    toExChange() {
      if (this.$store.state.app.shell === 'wechat') {
        window.location.href = "http://www.bestugo.com/metro/download.html"
        return false

      } else if (this.$store.state.app.shell !== 'bestugo' && this.$store.state.user.deviceCoding === '') {
        window.location.href = "http://www.bestugo.com/metro/download.html"
        return false
      }
      if (this.$store.state.user.token === '') {
        this.toGetUser2()
        return false
      }
      if (this.activityStatus === '0') {
        this.$toast('活动未开始')
        return false
      }
      if (this.activityStatus === '3') {
        this.$toast('活动不存在')
        return false
      }
      if (this.activityStatus === '2') {
        this.$toast('活动已结束')
        return false
      }
      if (this.activityStatus === '') {

        return false
      }

      this.$router.push({
        name: 'Exchange'
      })
    },

    toLink1() {
      if (window._czc) {

        window._czc.push(['_trackEvent', '绿色能量10月', '建行生活', '外链点击数', 1, '']);

      }

      // let linkUrl = "https://yunbusiness.ccb.com/gbchannel/e_report/outercoupon/#/CustomerActivity/20210223070000000255%20/ZF0002553522Q"
        let linkUrl ="https://yunbusiness.ccb.com/gbchannel/e_report/outercoupon/#/CustomerActivity/20210512010000000174/QD202105120104";
        if (this.$store.state.app.system === 'ios') {
        window.webkit.messageHandlers.QDMETRO_H5_NATIVE_EXPLORER.postMessage(linkUrl)
      } else {
        window.location.href = linkUrl


      }


    },
    towallet() {
      let startTime = Date.now()
      let that = this
      if (this.$store.state.user.deviceCoding !== '') {

        that.$dialog.confirm({
          title: '请先开通钱包',
          message: '当前活动需开通钱包方可参与',
          confirmButtonText: '去开通',
          cancelButtonText: '我已开通',
          closeOnPopstate: false,
          beforeClose: ((action, done) => {
            if (action === 'confirm') {

              // setTimeout(done, 1000);

              done(false)
              // that.toGetUser2()
              window.location.href = "com.qdmetro://wallet/index";
            } else {
              that.toGetUser()
              done();
            }
          })
        });
        window.location.href = "com.qdmetro://wallet/index";
        return false;
      }
      if (this.$store.state.app.shell === 'wechat') {
        window.location.href = "http://www.bestugo.com/metro/download.html"
      } else if (this.$store.state.app.system === 'ios') {
        window.location.href = "com.qdmetro://wallet/index";
        if (this.$store.state.app.shell === 'bestugo' || this.$store.state.user.deviceCoding !== '') return false;
        let interval = setInterval(function () {

          let endTime = Date.now();

          if (endTime - startTime < 5000) {

            window.location.href = "http://www.bestugo.com/metro/download.html";

            clearTimeout(interval);
          }

        }, 3000);
      } else if (this.$store.state.app.system === 'android') {
        window.location.href = "com.qdmetro://wallet/index";
        if (this.$store.state.app.shell === 'bestugo' || this.$store.state.user.deviceCoding !== '') return false;
        let interval = setInterval(function () {

          let endTime = Date.now();

          if (endTime - startTime < 7000) {

            window.location.href = "http://www.bestugo.com/metro/download.html";

            clearTimeout(interval);
          }

        }, 4000);
      }
    },
    toShare() {
      // let that=this
      // let startTime = Date.now()
      /*   this.$toast({
           duration: 3000, // 持续展示 toast
           message:'此活动邀请用户已达上限，邀请成功将不再获得绿色能量，感谢您的参与。',
         })
   */
      if (window._czc) {

        window._czc.push(['_trackEvent', '绿色能量10月', '邀请页' + '_' + this.$store.state.app.shell, '立即邀请按钮点击次数', 1, '']);

      }
      if (this.userPhone === '') {

        // this.$toast('3333')
        if (this.$store.state.app.shell !== 'bestugo' && this.$store.state.user.deviceCoding === '') {

          // window.location.href = "com.qdmetro://wallet/index";
          window.location.href = "http://www.bestugo.com/metro/download.html";
          return false;
          /*      let interval = setInterval(function () {

                  let endTime = Date.now();

                  if (endTime - startTime < 7000) {

                    window.location.href = "http://www.bestugo.com/metro/download.html";

                    clearTimeout(interval);
                  }

                }, 4000);*/
        } else {
          this.toGetUser2()
          return false
        }

      }
      /* if (this.pageStatus === 1) {
         this.$toast('活动已结束');
         return false
       }*/


      let onDate = Date.now()
      /*活动广告位及相关图片会在6月1日0时上线，但活动开始时间为6月1日17:00，在此之前奖品为无法兑换状态，立即邀请按钮也无法点击邀请；17:00之后按钮恢复正常状态。*/
      if (onDate < ActivityStartTime) {


        this.$toast('活动开始时间为10月1日17:00')
        return false;
      }


      let shareInfo = {
        title: '出行集能量，你行我也行 ',
        desc: '钱包乘车券、爱奇艺卡、京东E卡、话费好礼等你来兑！',
        image: 'http://appcdn.qd-metro.com/file/202103/30/20210430.jpg',
        url: window.location.origin + window.location.pathname  + '#/invite?uNo=' + this.userPhone
      }
      if (this.$store.state.app.system === 'ios') {

        let message = {
          "title": shareInfo.title,//可选，分享的标题，不传客户端标志为""
          "desc": shareInfo.desc, //可选，分享的描述，不传客户端标志位""
          "imageUrl": shareInfo.image, //分享的图片url,不传默认客户端的图标
          "url": shareInfo.url
        }
        // alert(JSON.stringify(message))
        window.webkit.messageHandlers.QDMETRO_H5_SHARE.postMessage(message)
      } else if (this.$store.state.app.system === 'android') {
        let rJsonObj = {
          title: shareInfo.title,
          url: shareInfo.url,
          thumb: shareInfo.image,
          desc: shareInfo.desc //
        }
        window.AndroidWebView.shareContent(JSON.stringify(rJsonObj))
      }
    }
  }
}
</script>
<style lang="less" scoped>
.home {
  //background-color: #eb1b00;
}

.yui_bg-main {
  width: 100%;
  height: auto;
  display: block;

}

.yui_banner {
  position: relative;

  .yui_banner-img {
    width: 100%;
    display: block;
  }

  .yui_banner-btn {
    position: absolute;
    right: 0;
    top: 20vw;
    background-color: #dc5c2ae0;
    display: block;
    padding: 2vw 5vw;
    font-size: 4vw;
    color: #ffffff;
    border-top-left-radius: 5vw;
    border-bottom-left-radius: 5vw;
  }
}

.yui_art {
  padding: 20px;
  text-align: left;
  word-break: break-all;
}

.yui_footer {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 5vw;

}

.y-main {
  position: absolute;
  //width: 60vw;
  top: 136vw;
  left: 10vw;
  right: 10vw;
  text-align: center;

  .yui-notice-bar {
    width: 60vw;
    margin: 0 auto;
    font-size: 3vw;
    height: 6vw;
    border-radius: 2vw;
  }


  .yui_card-1 {
    /*    position: absolute;
        top: 153vw;
        left: 12vw;
        right: 12vw;*/
    //background-color: #de7f1b50;
    width: 78vw;
    margin: 5vw auto 3vw;
    display: flex;
    align-items: flex-start;

    .yui_card-1_item {
      flex: 1;
      position: relative;

      h5 {
        margin: 3vw 0;
        font-size: 4vw;
        font-weight: 500;
      }

      p {
        margin: 0;
        line-height: 12vw;
        color: #ff9c11;
        font-size: 4vw;

        span {
          font-size: 9vw;

          //font-weight: 600;
        }
      }

      &:last-child:before {
        //position: absolute;
        //content: " ";
        //top: 0;
        //left: 0;
        //bottom: 0;
        //border-left: 1px solid #dfdfdf;
      }
    }
  }

  .y_task {
    position: relative;

    &:before {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      content: "";
      border-top: 1px solid #F5F5F5;
    }

    .task-item {
      font-size: 3vw;
      display: flex;
      align-items: center;
      padding: 3vw 2vw;

      .yui_cell-bd {
        flex: 1;
        position: relative;
        text-align: left;
        padding-left: 1.2em;

        .s1 {
          color: #499760;
          font-weight: 600;
        }

        &.yui_cell-bd-after-label:after {
          position: absolute;
          content: " *限开通钱包后七日内";
          bottom: -1.8em;
          left: 4vw;
          font-size: 2.6vw;
          color: #de7f1b;

        }
      }

      .yBtn-m {
        height: 5vw;
        font-size: 3vw;

        &.van-button--disabled {
          filter: grayscale(1);
        }
      }
    }
  }

  .btn-toDetail {
    //position: absolute;
    //top: 206vw;
    width: 80vw;
    /*left: 18vw;*/
    display: block;
    margin: 5vw auto;
  }

}


.btn-toExchangePrize {
  position: absolute;
  top: 348vw;
  width: 100vw;
  /*left: 2vw;*/
  display: block;
}

.btn-invite {
  width: 70vw;
  margin: 0 auto;
}

.yui-fix-footer {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 0 10vw 10vw;
  text-align: center;
}

.link-1 {
  position: absolute;
  top: 915vw;
  left: 7vw;
  width: 86vw;
  display: block;
}

.toExChange-text {
  position: absolute;
  top: 360vw;
  text-align: center;
  left: 0;
  right: 0;
  font-size: 3vw;
  line-height: 1;
  display: block;
}
</style>
